module.exports = __webpack_public_path__ + "img/2_1.f3098744.png";